import { render } from "./BuildingsPlan.vue?vue&type=template&id=4e201f48&scoped=true"
import script from "./BuildingsPlan.vue?vue&type=script&lang=js"
export * from "./BuildingsPlan.vue?vue&type=script&lang=js"

import "./BuildingsPlan.vue?vue&type=style&index=0&id=4e201f48&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e201f48"]])

export default __exports__